// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.react-modal-overlay.onboarding-progress-modal .react-modal {
  max-width: 35rem;
  height: -moz-fit-content;
  height: fit-content;
  max-height: 90%;
  margin: auto;
  padding: 0;
  border-radius: 6px;
  box-shadow: 0 0.5rem 1.063rem rgba(0, 0, 0, 0.1), 0 1.938rem 1.938rem rgba(0, 0, 0, 0.09), 0 4.313rem 2.563rem rgba(0, 0, 0, 0.05);
  border: none;
}
@media (max-width: 768px) {
  .react-modal-overlay.onboarding-progress-modal .react-modal {
    width: 35rem;
  }
}
.react-modal-overlay.onboarding-progress-modal .react-modal-content {
  width: 100%;
  display: flex;
  padding: unset;
  flex-direction: column;
  padding: 3.3rem;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .onboarding-progress-content {
  text-align: center;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .centered-image img {
  height: 7.25rem;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .message {
  font-family: "Libre-Baskerville", serif;
  font-style: italic;
  font-size: 1.667rem;
  margin: 1.9rem 0;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .tasks {
  text-align: left;
  margin: 1.9rem 0;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .task-wrapper {
  border-bottom: 0.083rem solid rgb(214, 214, 214);
  margin-bottom: 0.5rem;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .task {
  display: flex;
  align-items: center;
  margin: 0.5rem 0 0.417rem 0;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .artful-checkbox-wrapper {
  padding-left: 2.5rem;
  min-height: 2.2rem;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .artful-checkbox-wrapper label {
  font-size: 1.5rem;
  color: rgb(97, 97, 97);
}
.react-modal-overlay.onboarding-progress-modal .react-modal .artful-checkbox-wrapper label:before {
  top: -0.01rem;
  font-size: 2.2rem;
  color: rgb(219, 219, 219);
}
.react-modal-overlay.onboarding-progress-modal .react-modal .artful-checkbox-wrapper label.checked {
  color: rgb(172, 56, 102);
}
.react-modal-overlay.onboarding-progress-modal .react-modal .artful-checkbox-wrapper label.checked:before {
  color: rgb(172, 56, 102);
}
.react-modal-overlay.onboarding-progress-modal .react-modal .progress-bar-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .progress-bar-container {
  flex-grow: 1;
  background-color: rgba(172, 56, 102, 0.25);
  border-radius: 4px;
  height: 0.5rem;
  margin: 0.5rem 0;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .progress-bar {
  background-color: rgb(172, 56, 102);
  height: 100%;
  border-radius: 4px;
  transition: width 0.6s ease;
}
.react-modal-overlay.onboarding-progress-modal .react-modal .progress-percentage {
  margin-left: 10px;
  color: rgb(172, 56, 102);
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Onboarding/OnboardingProgressModal.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAEE;EACE,gBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EAKA,kIAAA;EAEA,YAAA;AAFJ;AAGI;EAdF;IAeI,YAAA;EAAJ;AACF;AAEI;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AAAN;AAGI;EACE,kBAAA;AADN;AAII;EACE,eAAA;AAFN;AAKI;EACE,uCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAHN;AAMI;EACE,gBAAA;EACA,gBAAA;AAJN;AAOI;EACE,gDAAA;EACA,qBAAA;AALN;AAQI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AANN;AASI;EACE,oBAAA;EACA,kBAAA;AAPN;AASM;EACE,iBAAA;EACA,sBAAA;AAPR;AAUM;EACE,aAAA;EACA,iBAAA;EACA,yBAAA;AARR;AAWM;EACE,wBAAA;AATR;AAYM;EACE,wBAAA;AAVR;AAcI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAZN;AAeI;EACE,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAbN;AAgBI;EACE,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AAdN;AAiBI;EACE,iBAAA;EACA,wBAAA;EACA,gBAAA;AAfN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import 'Variables.scss';\n\n.react-modal-overlay.onboarding-progress-modal {\n  .react-modal {\n    max-width: 35rem;\n    height: fit-content;\n    max-height: 90%;\n    margin: auto;\n    padding: 0;\n    border-radius: 6px;\n    -webkit-box-shadow: 0 0.5rem 1.063rem rgba(0, 0, 0, 0.1),\n      0 1.938rem 1.938rem rgba(0, 0, 0, 0.09), 0 4.313rem 2.563rem rgba(0, 0, 0, 0.05);\n    -moz-box-shadow: 0 0.5rem 1.063rem rgba(0, 0, 0, 0.1), 0 1.938rem 1.938rem rgba(0, 0, 0, 0.09),\n      0 4.313rem 2.563rem rgba(0, 0, 0, 0.05);\n    box-shadow: 0 0.5rem 1.063rem rgba(0, 0, 0, 0.1), 0 1.938rem 1.938rem rgba(0, 0, 0, 0.09),\n      0 4.313rem 2.563rem rgba(0, 0, 0, 0.05);\n    border: none;\n    @media (max-width: $tablet) {\n      width: 35rem;\n    }\n\n    &-content {\n      width: 100%;\n      display: flex;\n      padding: unset;\n      flex-direction: column;\n      padding: 3.3rem;\n    }\n\n    .onboarding-progress-content {\n      text-align: center;\n    }\n\n    .centered-image img {\n      height: 7.25rem;\n    }\n\n    .message {\n      font-family: 'Libre-Baskerville', serif;\n      font-style: italic;\n      font-size: 1.667rem;\n      margin: 1.9rem 0;\n    }\n\n    .tasks {\n      text-align: left;\n      margin: 1.9rem 0;\n    }\n\n    .task-wrapper {\n      border-bottom: 0.083rem solid rgb(214, 214, 214);\n      margin-bottom: 0.5rem;\n    }\n\n    .task {\n      display: flex;\n      align-items: center;\n      margin: 0.5rem 0 0.417rem 0;\n    }\n\n    .artful-checkbox-wrapper {\n      padding-left: 2.5rem;\n      min-height: 2.2rem;\n\n      label {\n        font-size: 1.5rem;\n        color: rgb(97, 97, 97);\n      }\n\n      label:before {\n        top: -0.01rem;\n        font-size: 2.2rem;\n        color: rgb(219, 219, 219);\n      }\n\n      label.checked {\n        color: rgb(172, 56, 102);\n      }\n\n      label.checked:before {\n        color: rgb(172, 56, 102);\n      }\n    }\n\n    .progress-bar-wrapper {\n      display: flex;\n      align-items: center;\n      width: 100%;\n    }\n\n    .progress-bar-container {\n      flex-grow: 1;\n      background-color: rgba(172, 56, 102, 0.25);\n      border-radius: 4px;\n      height: 0.5rem;\n      margin: 0.5rem 0;\n    }\n\n    .progress-bar {\n      background-color: rgb(172, 56, 102);\n      height: 100%;\n      border-radius: 4px;\n      transition: width 0.6s ease;\n    }\n\n    .progress-percentage {\n      margin-left: 10px;\n      color: rgb(172, 56, 102);\n      font-weight: 600;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
